'use strict';
module.exports = function placeCaretAtEnd(element) {
	if (!window.getSelection || !document.createRange) {
		return;
	}
	const range = document.createRange(),
		sel = window.getSelection();
	range.selectNodeContents(element);
	range.collapse(false);
	sel.removeAllRanges();
	sel.addRange(range);
};

